import { useState } from 'react'
import styled, { CSSObject } from '@emotion/styled'
import ToggleSwitchButton from '../Buttons/ToggleSwitchButton'
import { VisibileToggleDiv } from '../common'

type Props = {
  label: string
  switchName: string
  onToggle: (isChecked: boolean) => void
  defaultChecked?: boolean
  hideToggle?: boolean
}

const ToggleSwitchLabel = ({
  label,
  switchName,
  onToggle,
  defaultChecked = false,
  hideToggle = false
}: Props) => {
  const [isChecked, setIsChecked] = useState<boolean>(defaultChecked)

  const handleToggle = (isChecked: boolean) => {
    setIsChecked(isChecked)
    onToggle(isChecked)
  }

  return (
    <SwitchControlContainer>
      <Label>{label}</Label>
      <VisibileToggleDiv isVisible={!hideToggle}>
        <ToggleSwitchButton
          switchName={switchName}
          onToggle={handleToggle}
          defaultChecked={isChecked}
        />
      </VisibileToggleDiv>
    </SwitchControlContainer>
  )
}

const SwitchControlContainer = styled.div(
  (): CSSObject => ({
    display: 'flex',
    alignContent: 'center',
    gap: '32px',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between'
  })
)

const Label = styled.span(
  ({ theme }): CSSObject => ({
    fontWeight: 500,
    fontSize: '16px'
  })
)

export default ToggleSwitchLabel
